import { render, staticRenderFns } from "./CustomLP.vue?vue&type=template&id=180168ec&"
import script from "./CustomLP.vue?vue&type=script&lang=js&"
export * from "./CustomLP.vue?vue&type=script&lang=js&"
import style0 from "./CustomLP.vue?vue&type=style&index=0&id=180168ec&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports